import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'
import { UserRole } from '../../shared/interfaces/user.interface'

/**
 * Ensures COACH role users can only access their assigned teams.
 * Non-COACH roles pass through unaffected.
 */
export const coachTeamGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  const user = authService.currentUser()
  if (!user || user.role !== UserRole.COACH) return true

  const teamId = route.paramMap.get('teamId')
  if (teamId && authService.hasTeamAccess(teamId)) return true

  return router.createUrlTree(['/unauthorized'])
}
